<template>
  <main class="profile-page">
    <h1 class="rebate-header profilehead">{{ $t("profilehome.mydashboard") }}</h1>

    <!-- <b-button-group size="sm">
  <b-button :pressed.sync="cad" variant="outline-dark">{{ $t("certificate.ca") }}</b-button>
    <b-button :pressed.sync="usd" variant="outline-dark">{{ $t("certificate.us") }}</b-button>
  </b-button-group> -->

    <!-- <br><br> -->

    <b-row class="tierprogress">
      <b-col cols="12">
        <b-row class="progressbars">
          <b-col cols="1">
            <p>
              <strong>{{ $t("certificate.tiers") }}</strong>
            </p>
            <div class="hiddenbox"></div>
            <p class="bucksdescript">{{ $t("certificate.purchasedc") }}</p>
            <p class="bucksdescript">{{ $t("certificate.trainingbucks") }}</p>
          </b-col>

          <b-col>
            <p><strong>1</strong></p>
            <b-progress height="4rem" :value="tier[0]" :variant="'secondary'" class="mb-3 first"></b-progress>
            <p v-if="$router.currentRoute.params.lang == 'en'">{{ $t("certificate.currency", { msg: "2,500" }) }}</p>
            <p v-if="$router.currentRoute.params.lang == 'fr'">{{ $t("certificate.currency", { msg: "2 500" }) }}</p>
            <p>{{ $t("certificate.tier1") }}</p>
          </b-col>

          <b-col>
            <p><strong>2</strong></p>
            <b-progress height="4rem" :value="tier[1]" :variant="'secondary'" class="mb-3"></b-progress>
            <p v-if="$router.currentRoute.params.lang == 'en'">{{ $t("certificate.currency", { msg: "3,000" }) }}</p>
            <p v-if="$router.currentRoute.params.lang == 'fr'">{{ $t("certificate.currency", { msg: "3 000" }) }}</p>
            <p>{{ $t("certificate.tier2") }}</p>
          </b-col>

          <b-col>
            <p><strong>3</strong></p>
            <b-progress height="4rem" :value="tier[2]" :variant="'secondary'" class="mb-3"></b-progress>
            <p v-if="$router.currentRoute.params.lang == 'en'">{{ $t("certificate.currency", { msg: "5,000" }) }}</p>
            <p v-if="$router.currentRoute.params.lang == 'fr'">{{ $t("certificate.currency", { msg: "5 000" }) }}</p>
            <p>{{ $t("certificate.tier3") }}</p>
            <p>{{ $t("certificate.tier3two") }}</p>
            <p>{{ $t("certificate.tier3three") }}</p>
          </b-col>

          <b-col>
            <p><strong>4</strong></p>
            <b-progress height="4rem" :value="tier[3]" :variant="'secondary'" class="mb-3"></b-progress>
            <p v-if="$router.currentRoute.params.lang == 'en'">{{ $t("certificate.currency", { msg: "6,500" }) }}</p>
            <p v-if="$router.currentRoute.params.lang == 'fr'">{{ $t("certificate.currency", { msg: "6 500" }) }}</p>
            <p>{{ $t("certificate.tier4") }}</p>
          </b-col>

          <b-col>
            <p><strong>5</strong></p>
            <b-progress height="4rem" :value="tier[4]" :variant="'secondary'" class="mb-3"></b-progress>
            <p v-if="$router.currentRoute.params.lang == 'en'">{{ $t("certificate.currency", { msg: "10,000" }) }}</p>
            <p v-if="$router.currentRoute.params.lang == 'fr'">{{ $t("certificate.currency", { msg: "10 000" }) }}</p>
            <p>{{ $t("certificate.tier5") }}</p>
          </b-col>
        </b-row>
      </b-col>

      <b-col>
        <b-button tabindex="0" :to="'/' + $router.currentRoute.params.lang + '/start'" class="mmm-button next"
          >+ {{ $t("certificate.newsubmission") }}
          <hr class="mmm-bar main-gradient" />
          <hr class="white-bar" />
        </b-button>
        <!-- :disabled="!generate"  -->
        <!-- <b-button tabindex='0' v-on:click="redeem(cad)" :disabled="!generate"  class='mmm-button next'>{{ $t("certificate.redeemnow") }}
              <hr class='mmm-bar main-gradient' />
              <hr class='white-bar' />
            </b-button> -->

        <b-button tabindex="0" v-b-modal.redeem :disabled="!generate" class="mmm-button next"
          >{{ $t("certificate.redeemnewproduct") }}
          <hr class="mmm-bar main-gradient" />
          <hr class="white-bar" />
        </b-button>

        <b-modal v-model="modalShow" id="redeem" size="lg" centered scrollable v-bind:title="$t('certificate.redeemnewproduct')" ok-only :ok-title="$t('master.cancel')" hide-header-close>
          <p>{{ $t("certificate.eligible") }}</p>

          <p>{{ $t("certificate.select") }}</p>

          <b-form-select v-if="$router.currentRoute.params.lang == 'en'" v-model="product" class="mb-3">
            <b-form-select-option v-for="producted in products" v-bind:key="producted.id" v-bind:value="producted">{{ producted.name }}</b-form-select-option>
          </b-form-select>

          <b-form-select v-if="$router.currentRoute.params.lang == 'fr'" v-model="product" class="mb-3">
            <b-form-select-option v-for="producted in products" v-bind:key="producted.id" v-bind:value="producted">{{ producted.name_fr }}</b-form-select-option>
          </b-form-select>

          <!-- <b-row v-if="product" class="card-row">
                <b-col col cols="4">
<img v-if="product.image_url" class="img-fluid product-img" v-bind:alt="(il8n && il8n.local == 'en') ? product.description : product.description_fr" v-bind:src="api + '/api/images/' + product.image_url">
<img v-else class="img-fluid product-img" src='../assets/noimage.svg' :alt="$t('master.noimage')">
                  </b-col>
                 <b-col col cols="8">
                   <b-row>
                     <b-col col cols="12">
                      <p class="product"><strong>{{ product.name }}</strong></p>
                      <p class="desc" v-if="i18n.locale == 'en'">{{ product.description }}</p>
                      <p class="desc" v-else-if="i18n.locale == 'fr'">{{ product.description_fr }}</p>
                      </b-col>
                   </b-row>
                 </b-col>

                 
               </b-row> -->

          <div v-if="product">
            <p>{{ $t("certificate.selectmodel") }}</p>
            <b-form-select v-model="model" class="mb-3">
              <b-form-select-option v-for="reward in product.reward_options" v-bind:key="reward.id" v-bind:value="reward">
                <span v-if="reward.model">{{ $t("certificate.model") }} : {{ reward.model }}</span>
                <span v-if="reward.diameter"> / {{ $t("certificate.diameter") }} : {{ reward.diameter }}</span>
                <span v-if="reward.orbit"> / {{ $t("certificate.orbit") }} : {{ reward.orbit }}</span>
                <span v-if="reward.discpad"> / {{ $t("certificate.discpad") }} : {{ reward.discpad }}</span>
                <span v-if="reward.motor"> / {{ $t("certificate.motor") }} : {{ reward.motor }} HP</span>
                <span v-if="reward.rpm"> / {{ $t("certificate.rpm") }} : {{ reward.rpm }}</span>
              </b-form-select-option>
            </b-form-select>
          </div>

          <div v-if="model && $router.currentRoute.params.lang == 'en'">
            {{ $t("certificate.productredeem", { msg: product.name }) }} <strong>{{ product.name }} ({{ $t("certificate.model") }}: {{ model.model }})</strong>.
            <p v-html="$t('certificate.productredeem2', { msg: product.tier })"></p>
          </div>

          <div v-if="model && $router.currentRoute.params.lang == 'fr'">
            {{ $t("certificate.productredeem", { msg: product.name_fr }) }} <strong>{{ product.name_fr }} ({{ $t("certificate.model") }}: {{ model.model }})</strong>.
            <p v-html="$t('certificate.productredeem2', { msg: product.tier })"></p>
          </div>
          <br />

          <b-button tabindex="0" v-on:click="redeem(cad)" :disabled="!model" class="mmm-button next final"
            >{{ $t("certificate.redeemnow") }}
            <hr class="mmm-bar main-gradient" />
            <hr class="white-bar" />
          </b-button>
        </b-modal>

        <!-- <p>{{ $t("certificate.redeemdisc") }}</p> -->
      </b-col>

      <b-col class="redeemstatus">
        <p><strong v-html="$t('certificate.currency', { msg: purchasedtotal })"></strong> {{ $t("certificate.purchased") }}.</p>
        <p>
          <strong>{{ $t("certificate.currency", { msg: togo }) }}</strong> {{ $t("certificate.tiergoal") }} {{ tiernumber }}.
        </p>

        <div v-if="$router.currentRoute.params.lang == 'en'">
          <p v-if="!redeemable == 0">
            <strong>{{ redeemable }}</strong> {{ $t("certificate.available") }}.
          </p>
        </div>
        <div v-if="$router.currentRoute.params.lang == 'fr'">
          <p v-if="!redeemable == 0"><strong>Les produits</strong> qui peuvent être réclamés dès maintenant.</p>
        </div>
      </b-col>
    </b-row>

    <div v-if="myCertificates.length > 0" class="my-submissions">
      <h2>{{ $t("certificate.mycertificates") }}</h2>

      <!-- {{myRebates[0]}} -->
      <div class="my-rebates">
        <div class="table-row" id="my-table" :items="myCertificates" v-for="certificate in myCertificates" v-bind:key="certificate.id">
          <ul class="submission-base">
            <li class="child-column dropShadow">
              <div class="submission-info">
                <ul>
                  <li>
                    <span>{{ $t("certificate.value") }} :</span> {{ $t("certificate.currency", { msg: valuefix(certificate.value) }) }}
                  </li>
                  <li>
                    <span>{{ $t("certificate.certid") }} :</span> {{ certificate.certid }}
                  </li>
                  <li>
                    <span>{{ $t("certificate.issuedate") }} :</span> {{ certificate.issuedate | moment("MMMM Do YYYY") }}
                  </li>
                  <!-- <li><span>{{ $t("certificate.dateofexpiry") }} :</span>{{ certificate.expirydate | moment("MMMM Do YYYY") }}</li>              -->
                  <li>
                    <span>{{ $t("certificate.shipped") }} :</span> <span v-if="(certificate.shipped == 0) | !certificate.shipped">Not Shipped</span> <span v-if="certificate.shipped == 1">Shipped</span>
                  </li>
                  <li>
                    <span>{{ $t("certificate.tracking") }} :</span> {{ certificate.tracking }}
                  </li>
                </ul>
              </div>
            </li>
            <li class="child-column dropShadow">
              <b-row class="card-row">
                <b-col col cols="4" class="centerize">
                  <img v-if="certificate.reward.image_url" class="img-fluid product-img" v-bind:alt="il8n && il8n.local == 'en' ? certificate.reward.description : certificate.reward.description_fr" v-bind:src="api + '/api/images/' + certificate.reward.image_url" />
                  <img v-else class="img-fluid product-img" src="../assets/noimage.svg" :alt="$t('master.noimage')" />
                </b-col>
                <b-col col class="redemptionbuffer" cols="8">
                  <b-row>
                    <p class="product" v-if="$router.currentRoute.params.lang == 'en'">
                      <strong>{{ certificate.reward.name }}</strong>
                    </p>
                    <p class="product" v-if="$router.currentRoute.params.lang == 'fr'">
                      <strong>{{ certificate.reward.name_fr }}</strong>
                    </p>
                    <p class="desc" v-if="i18n.locale == 'en'">{{ certificate.reward.description }}</p>
                    <p class="desc" v-else-if="i18n.locale == 'fr'">{{ certificate.reward.description_fr }}</p>

                    <b-row class="moreproductinfo" v-if="certificate.option">
                      <b-table-simple hover small caption-top responsive>
                        <b-thead head-variant="dark">
                          <b-tr>
                            <b-th v-if="certificate.option.model">{{ $t("certificate.model") }}</b-th>
                            <b-th v-if="certificate.option.diameter">{{ $t("certificate.diameter") }}</b-th>
                            <b-th v-if="certificate.option.orbit">{{ $t("certificate.orbit") }}</b-th>
                            <b-th v-if="certificate.option.discpad">{{ $t("certificate.discpad") }}</b-th>
                            <b-th v-if="certificate.option.motor">{{ $t("certificate.motor") }}</b-th>
                            <b-th v-if="certificate.option.rpm">{{ $t("certificate.rpm") }}</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr>
                            <b-td v-if="certificate.option.model">{{ certificate.option.model }}</b-td>
                            <b-td v-if="certificate.option.diameter">{{ certificate.option.diameter }} <span v-if="i18n.locale == 'en'">in</span><span v-if="i18n.locale == 'fr'">po</span></b-td>
                            <b-td v-if="certificate.option.orbit">{{ certificate.option.orbit }}</b-td>
                            <b-td v-if="certificate.option.discpad && i18n.locale == 'en'">{{ certificate.option.discpad }}</b-td>
                            <b-td v-if="certificate.option.discpad && i18n.locale == 'fr'">{{ certificate.option.discpad_fr }}</b-td>
                            <b-td v-if="certificate.option.motor">{{ certificate.option.motor }} HP</b-td>
                            <b-td v-if="certificate.option.rpm">{{ certificate.option.rpm }}</b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </b-row>
                  </b-row>
                </b-col>
              </b-row>
            </li>
          </ul>
        </div>

        <br /><br />
      </div>
    </div>

    <div class="my-submissions">
      <h2>{{ $t("profilehome.myrebates") }}</h2>

      <!-- {{myRebates[0]}} -->
      <div v-if="myRebates.length > 0" class="my-rebates">
        <div class="table-row" id="my-table" :items="myRebates" :per-page="perPage" :current-page="currentPage" v-for="rebate in myRebates.slice(6 * (currentPage - 1), 6 * currentPage)" v-bind:key="rebate.id">
          <ul class="submission-base">
            <li class="child-column dropShadow">
              <div class="submission-info">
                <ul>
                  <li>
                    <span>{{ $t("profilehome.submissionid") }} : </span>{{ rebate.id }}
                  </li>
                  <!-- moment().format('MMMM Do YYYY, h:mm:ss a'); -->
                  <!-- {{ someDate | moment("dddd, MMMM Do YYYY") }} -->
                  <!-- <li><span>{{ $t('profilehome.created') }}:</span> {{rebate.created_at}}</li> -->
                  <li>
                    <span>{{ $t("profilehome.created") }} : </span>{{ rebate.created_at | moment("MMMM Do YYYY") }}
                  </li>
                  <!-- <li v-if="i18n.locale == 'en'"><span>{{ $t('profilehome.rebatevalue') }}:</span> ${{rebate.totalAmount}}</li>
                            <li v-else-if="i18n.locale == 'fr'"><span>{{ $t('profilehome.rebatevalue') }}:</span> {{rebate.totalAmount}} $</li> -->

                  <li>
                    <span>{{ $t("certificate.purchasetotal") }} : </span><strong v-if="rebate.payment_section" v-html="$t('certificate.currency', { msg: valuefix(rebate.payment_section.payment_amount_cad) })"></strong><strong v-if="!rebate.payment_section">{{ $t("certificate.currency", { msg: "0" }) }}</strong> CAD
                  </li>
                  <li>
                    <span>{{ $t("certificate.remainingvalue") }} : </span><strong v-if="rebate.payment_section" v-html="$t('certificate.currency', { msg: valuefix(rebate.payment_section.remainingvalue) })"></strong><strong v-if="!rebate.payment_section">{{ $t("certificate.currency", { msg: "0" }) }}</strong> CAD
                  </li>
                  <!-- <li><span>Submitted Invoice(s) : </span>000</li> -->
                </ul>
              </div>
            </li>
            <li class="child-column dropShadow">
              <div class="submission-status">
                <div class="status">
                  <h3>{{ $t("profilehome.currentstatus") }} :</h3>
                  <h4 :class="rebate.submission_status.status.toLowerCase().replace(/\s/g, '') + '-bg status-symbol'">
                    <div v-if="$router.currentRoute.params.lang == 'en'">{{ rebate.submission_status.status }}</div>
                    <div v-if="$router.currentRoute.params.lang == 'fr' && rebate.submission_status.status == 'Approved'">Acceptée</div>
                    <div v-if="$router.currentRoute.params.lang == 'fr' && rebate.submission_status.status == 'Pending'">En attente</div>
                  </h4>

                  <h4 v-if="rebate.submission_status.status != 'Approved'" class="declined-bg status-symbol">{{ $t("certificate.unredeemable") }}</h4>
                  <h4 v-if="rebate.submission_status.status == 'Approved' && rebate.payment_status == 1" class="pending-bg status-symbol">{{ $t("certificate.redeemable") }}</h4>
                  <h4 v-if="rebate.submission_status.status == 'Approved' && rebate.payment_status == 2" class="approved-bg status-symbol">{{ $t("certificate.unredeemable") }}</h4>
                </div>

                <!-- Pending -->
                <p v-if="rebate.status == 1" class="explanation">{{ $t("profilehome.businessdays") }}</p>

                <!-- Need Info -->
                <p v-else-if="rebate.status == 2" class="explanation">{{ $t("profilehome.moreinfo") }} {{ $t("profilehome.moreinfoclick") }} {{ rebate.customer_info.comments }}</p>

                <!-- Declined -->
                <p v-else-if="rebate.status == 3" class="explanation">{{ $t("profilehome.declined") }} {{ $t("profilehome.moreinfoclick") }} {{ rebate.customer_info.comments }}</p>

                <!-- Approved -->
                <p v-else-if="rebate.status == 4" class="explanation">{{ $t("profilehome.approved") }}</p>
              </div>
            </li>
          </ul>
        </div>

        <div class="mt-3 text-center">
          <b-pagination align="center" v-model="currentPage" :total-rows="rows" :items="myRebates" :per-page="perPage" aria-controls="my-table"></b-pagination>
        </div>
        <br /><br />
      </div>

      <div v-else class="no-rebates">
        <h3>
          {{ $t("profilehome.clickstartfirstrebate") }} <router-link class="standard-link" :to="'/' + $router.currentRoute.params.lang + '/start'">{{ $t("profilehome.clickhere") }}</router-link> {{ $t("profilehome.tocreate") }}
        </h3>
      </div>
    </div>
  </main>
</template>

<script>
import { getHeader, uploadHeader, getHeaderAuth, uploadHeaderAuth } from "../headers.js";

export default {
  name: "app",
  data() {
    return {
      myRebates: [],
      myCertificates: [],
      cad: false,
      usd: false,
      perPage: 6,
      currentPage: 1,
      tier: [0, 0, 0, 0, 0],
      purchasedtotal: 0,
      togo: 2500,
      redeemable: "",
      tiernumber: 1,
      generate: false,
      products: [],
      product: "",
      model: "",
      modalShow: false,
      il8n: "",
    };
  },
  methods: {
    valuefix: function(value) {
      let vm = this;
      if (vm.i18n.locale == "en") {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
    },

    redeem: function(currency) {
      var country = "ca";
      var locale = "en";

      let vm = this;
      let dom = this.api + "/api/redeem";
      vm.modalShow = false;

      vm.axios
        .post(
          dom,
          { reward: vm.product.id, option: vm.model.id },
          {
            headers: uploadHeaderAuth(vm.$session.get("jwt")),
            // eslint-disable-next-line
          },
        )
        .then(function(response) {
          vm.resetData();
          vm.getMySubmissions(locale);
          vm.getMyCertificates(country);
          console.log(response);
        });
    },
    resetData: function() {
      let vm = this;
      vm.myRebates = [];
      vm.myCertificates = [];
      vm.tier = [0, 0, 0, 0, 0];
      vm.purchasedtotal = 0;
      vm.togo = 0;
      vm.redeemable = 0;
      vm.tiernumber = 1;
      vm.generate = false;
    },

    getMyCertificates: function(currency) {
      let vm = this;
      let dom = this.api + "/api/get-my-certificates/" + currency;

      //We will need to pass authentication tokens in the Second param in get() method.
      this.axios
        .get(dom, { headers: getHeaderAuth(vm.$session.get("jwt")) })
        .then(function(response) {
          vm.myCertificates = response.data.data;
          console.log(response);
        })
        .catch(function(error) {});
    },

    getMySubmissions: function(currency) {
      let vm = this;
      let dom = this.api + "/api/get-my-rebates/" + currency;

      //We will need to pass authentication tokens in the Second param in get() method.
      this.axios
        .get(dom, { headers: getHeaderAuth(vm.$session.get("jwt")) })
        .then(function(response) {
          vm.myRebates = response.data.data;

          console.log(response.data);

          response.data.data.map(function(value, key) {
            if (value.payment_section && value.payment_status === 1) {
              vm.purchasedtotal = parseInt(value.payment_section.remainingvalue, 10) + parseInt(vm.purchasedtotal, 10);
            }
          });

          if (vm.purchasedtotal >= 1 && vm.purchasedtotal <= 2499) {
            //Progress
            vm.redeemable = vm.$i18n.t("certificate.tier0");
            vm.tiernumber = 1;
            vm.togo = 2500 - vm.purchasedtotal;
            //Interactive Status Bar
            var decreaseValue = 2500 - vm.togo;
            vm.tier = [(decreaseValue / 2500) * 100, 0, 0, 0, 0];
            vm.generate = false;
          }
          if (vm.purchasedtotal >= 2500 && vm.purchasedtotal <= 2999) {
            //Progress
            vm.redeemable = vm.$i18n.t("certificate.tier1");
            vm.tiernumber = 2;
            var tiermax = 3000;
            var tiermin = 2500;

            vm.togo = tiermax - vm.purchasedtotal;
            //Interactive Status Bar
            var decreaseValue = 3000 - vm.togo;
            vm.tier = [100, ((decreaseValue - tiermin) / (tiermax - tiermin)) * 100, 0, 0, 0];
            vm.generate = true;
          }

          if (vm.purchasedtotal >= 3000 && vm.purchasedtotal <= 4999) {
            //Progress

            vm.redeemable = "Products";
            vm.tiernumber = 3;
            var tiermax = 5000;
            var tiermin = 3000;

            vm.togo = tiermax - vm.purchasedtotal;
            //Interactive Status Bar
            var decreaseValue = 5000 - vm.togo;
            vm.tier = [100, 100, ((decreaseValue - tiermin) / (tiermax - tiermin)) * 100, 0, 0];
            vm.generate = true;
          }

          if (vm.purchasedtotal >= 5000 && vm.purchasedtotal <= 6499) {
            //Progress

            vm.redeemable = "Products";

            vm.tiernumber = 4;
            var tiermax = 6500;
            var tiermin = 5000;
            vm.togo = tiermax - vm.purchasedtotal;
            //Interactive Status Bar
            var decreaseValue = 6500 - vm.togo;
            vm.tier = [100, 100, 100, ((decreaseValue - tiermin) / (tiermax - tiermin)) * 100, 0];
            vm.generate = true;
          }

          if (vm.purchasedtotal >= 6500 && vm.purchasedtotal <= 9999) {
            //Progress
            vm.redeemable = "Products";
            vm.tiernumber = 5;
            var tiermax = 10000;
            var tiermin = 6500;
            vm.togo = tiermax - vm.purchasedtotal;
            //Interactive Status Bar
            var decreaseValue = 10000 - vm.togo;
            vm.tier = [100, 100, 100, 100, ((decreaseValue - tiermin) / (tiermax - tiermin)) * 100];
            vm.generate = true;
          }

          if (vm.purchasedtotal >= 10000 && vm.purchasedtotal <= 1000000) {
            //Progress
            vm.redeemable = "Products";
            vm.tiernumber = 5;
            vm.togo = 0;
            //Interactive Status Bar
            vm.tier = [100, 100, 100, 100, 100];
            vm.generate = true;
          }

          // vm.purchasedtotal;
          if (vm.i18n.locale == "en") {
            vm.purchasedtotal = vm.purchasedtotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            vm.togo = vm.togo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            vm.purchasedtotal = vm.purchasedtotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            vm.togo = vm.togo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
          }

          // vm.redeemable = vm.redeemable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        })
        .catch(function(error) {
          // handle error
          // eslint-disable-next-line
          if (error.response.data.message && error.response.data.message == "Unauthenticated.") {
            vm.loggedin = false;
            vm.user = [];
            this.$session.clear();
            vm.$router.push({ path: "Login", params: { lang: vm.$router.currentRoute.params.lang } });
            return;
          }
          vm.errors = error.response.data.errors;
        });
    },

    checkRedeem: function() {
      let vm = this;
      let dom = this.api + "/api/check-redeem";

      this.axios.get(dom, { headers: uploadHeaderAuth(vm.$session.get("jwt")) }).then(function(response) {
        vm.products = response.data;
        console.log(response);
      });
    },

    formatNumber: function(numb) {
      return numb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted: function() {
    let vm = this;
    if (vm.i18n.locale == "en_us") {
      var locale = "us";
      vm.usd = true;
    } else {
      var locale = "ca";
      vm.cad = true;
      if (vm.i18n.locale == "en_fr") {
        console.log(vm.$moment.locale("fr"));
      }
    }

    this.$root.$on("bv::modal::show", () => {
      // bvEvent <- Was a param
      // if(bvEvent.target.id == 'productsbox') {
      this.modalShow = true;
      // }
      this.checkRedeem();
    });
  },

  watch: {
    cad: function() {
      let vm = this;
      if (vm.cad == true) {
        vm.usd = false;
        this.resetData();
        this.getMySubmissions("en");
        this.getMyCertificates("ca");
      }
    },
    usd: function() {
      let vm = this;
      if (vm.usd == true) {
        vm.cad = false;
        this.resetData();
        this.getMySubmissions("en_us");
        this.getMyCertificates("us");
      }
    },
  },

  computed: {
    rows() {
      return this.myRebates.length;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
.rebate-header {
  padding: 1rem;
  padding-top: 5rem;
  font-size: 2.5rem;
  text-align: center;
}
.my-submissions {
  h2 {
    font-size: 1.5rem;
    padding: 1rem;
    margin-bottom: 2rem;
  }
}
.submission-base {
  display: flex;
  margin: 0;
  width: 100%;
  justify-content: center;
  padding: 0;
  .child-column {
    .explanation {
      font-size: 0.85rem;
      color: $mmm-gray;
      padding: 0.5rem 0.55rem;
    }
    width: 40%;
    margin: 0;
    list-style: none;
    border-right: 2px solid #f1f1f3;
    margin-bottom: 25px;
    display: flex;
    position: relative;
    align-items: center;
    &:last-child {
      width: 60%;
    }
    ul {
      li {
        border: 0;
        width: 100%;
        padding: 0;
        margin: 0;
      }
    }
    .submission-info {
      list-style: none;
      padding: 1.5rem;
      margin: 0;
      ul {
        padding: 0;
        li {
          margin: 0;
          padding: 0;
          text-align: left;
          span {
            font-family: $bold;
            color: #2c3e50;
            margin-right: 10px;
          }
          list-style: none;
          margin-bottom: 10px;
          color: $mmm-gray;
        }
      }
    }
    .submission-cta {
      align-self: center;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      height: 100%;
      width: 100%;
      padding: 2rem 1rem;
      align-self: flex-start;
      a {
        width: 100%;
        font-size: 0.75rem;
      }
    }
    .submission-status {
      text-align: left;
      padding: 1.5rem 1.2rem;
      .status {
        display: flex;
        align-content: center;
        // justify-content: center;
        align-items: center;
        h3 {
          padding: 0;
          text-align: left;
          font-size: 1rem;
          margin-right: 10px;
        }
        h4 {
          text-align: center;
        }
        @media (max-width: 995px) {
          flex-direction: column;
        }
      }
    }
    .payment-status {
      margin: 0 auto;
      position: relative;
      padding: 1rem;
      .status {
        display: flex;
        align-content: center;
        justify-content: center;
        align-items: center;
        h3 {
          padding: 0;
          text-align: center;
          font-size: 0.75rem;
          margin-right: 10px;
        }
        h4 {
          text-align: center;
          font-size: 0.75rem;
        }
        @media (max-width: 995px) {
          flex-direction: column;
        }
      }
      p {
        text-align: left;
        margin: 0 auto;
        position: relative;
        display: block;
        flex-grow: 0;
      }
    }
    // .
  }
  @media (max-width: 768px) {
    flex-direction: column;
    max-width: 90%;
    margin: 0 auto;
    position: relative;
    margin-bottom: 4rem;
    .child-column {
      width: 100%;
      margin: 0;
      border: 0;
      &:last-child {
        width: 100%;
      }
      .submission-info {
        background-color: #eee;
        width: 100%;
        padding: 1rem;
        ul {
          li:first-child {
            font-family: $bold;
            color: #2c3e50;
            font-size: 1.5rem;
            margin-bottom: 15px;
            span {
              margin: 0;
            }
          }
          li {
            margin: 0;
            text-align: center;
          }
        }
      }
      .payment-status p,
      p {
        text-align: center;
      }
      .submission-cta a {
        font-size: 1.1rem;
      }
    }
  }
}
.no-rebates {
  h3 {
    text-align: center;
    font-size: 1rem;
    font-family: $regular;
    top: -10px;
    padding: 1rem;
    position: relative;
    display: block;
  }
}

.mmm-button.next {
  width: 88%;
  &.final {
    width: 100%;
  }
}

.row.tierprogress {
  background: #ebebeb;
  padding: 3rem 20px;
  width: 90%;
  margin: auto !important;
  margin-bottom: 2rem !important;
}
.redeemstatus.col p {
  text-align: left;
  font-size: 1.4rem;
}

h4.approved-bg.status-symbol {
  margin: 3px;
}
.row.progressbars .col {
  padding: 0;
  margin: 0;
}

.row.progressbars {
  margin-bottom: 3rem !important;
}

.progress {
  margin: 0;
  margin-bottom: 1rem !important;
  background-color: #f8f9fa;
  border-radius: 0;
  border-right: 4px solid;
  &.first {
    border-left: 4px solid;
  }
}
.row.progressbars p {
  text-align: right;
  line-height: 1.1rem;
  font-size: 0.7rem;
  padding: 0 10px;
  @media (min-width: 670px) {
    font-size: 0.8rem;
    padding: 0 10px;
  }

  @media (min-width: 768px) {
    font-size: 1rem;
    padding: 0 10px;
  }
}
button.btn.mmm-button.next.btn-secondary:disabled {
  border-color: gray;
  color: gray;
}
.hiddenbox {
  height: 5rem;
}
p.bucksdescript {
  line-height: 15px !important;
}
.row.progressbars {
  display: none;
  @media (min-width: 550px) {
    display: flex;
  }
}

h4.pending-bg.status-symbol,
h4.declined-bg.status-symbol,
h4.approved-bg.status-symbol {
  margin: 2px;
  border-radius: 0;
}

p.desc,
p.product {
  text-align: left;
}
.centerize.col.col-4 {
  justify-content: end;
  align-items: center;
  display: flex;
}
.redemptionbuffer.col.col-8 {
  padding: 15px 5px;
}
</style>
